import Breadcrumb from "../utlis/Breadcrumb";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import HeadingPage from "../utlis/HeadingPage";
function Sports() {
  return (
    <>
      {/* ================= HEADER ================= */}
      <Header />

      {/* ================= BREADCRUMB / INNER SLIDER ================= */}
      <div className="InnerSld">
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="Sports Corner"
          title2=""
          parentTitle="Facilities"
          path="Sports Corner"
        />
      </div>

      {/* ================= ABOUT CONTENT ================= */}
      <div className="innerbody">
        <div className="container-fluid">
          <div className="row about-grid align-items-stretch">
            {/* Left Content */}
            <div className="col-12 col-xl-8">
              <div className="contact-form-card">
                <h2 className="about-title">Sports Corner</h2>

                <div className="about-content-card">
                  <p>
                    We teach aerobics exercise to the students, which is
                    important for students because it helps students to enhance
                    their cardio respiratory fitness and build strong bones and
                    muscles. In addition, it also controls weight and reduces
                    the symptoms of anxiety and depression. As the most
                    prominent and obvious benefit – the use of physical
                    activities throughout the curriculum help to improve your
                    student’s overall current physical fitness. Ensuring that
                    children are physically fit from a young age can help
                    prevent future health issues such as diabetes, heart
                    disease, asthma and high blood pressure. The school has
                    large playgrounds and well-maintained facilities for outdoor
                    and indoor games, including cricket, football, volley ball
                    and basketball. Students are expected to take part in these
                    games. A lot of attention is given towards physical
                    activities in school. Students are encouraged to take part
                    in outdoor games. Apart from the usual period allotted in
                    the timetable for physical training, the school holds annual
                    sports held in the winter, and students from all the four
                    houses (AVILA, EUPHRASIA CHAVARA,TRESA) take part in a
                    healthy competition. The school also encourages students to
                    take part in various Inter-school competitions.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Image */}
            <div className="col-12 col-xl-4">
              <div className="contact-map-card about-image-card">
                <div className="about-image-wrap">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/Sports.jpg"
                    alt="About School"
                    className="about-main-image img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= FOOTER ================= */}
      <Footer />
    </>
  );
}

export default Sports;
